import Chip from "@mui/material/Chip";

const BADGE_TONES = {
  danger: {
    backgroundColor: "#fef2f2",
    borderColor: "#fca5a5",
    color: "#b91c1c",
  },
  neutral: {
    backgroundColor: "#f8fafc",
    borderColor: "#cbd5e1",
    color: "#475569",
  },
  warning: {
    backgroundColor: "#fffbeb",
    borderColor: "#fcd34d",
    color: "#a16207",
  },
};

/** Compact, non-interactive indicator for a record's current status. */
export function StatusBadge({label, tone = "neutral"}) {
  const colors = BADGE_TONES[tone] ?? BADGE_TONES.neutral;

  return (
    <Chip
      aria-label={label}
      className={`status-badge status-badge--${tone}`}
      label={label}
      role="status"
      size="small"
      variant="outlined"
      sx={{
        ...colors,
        borderRadius: "999px",
        fontFamily: '"Rubik", sans-serif',
        fontSize: "14px",
        fontWeight: 600,
        height: "32px",
        letterSpacing: "0.01em",
        "& .MuiChip-label": {
          paddingInline: "14px",
        },
      }}
    />
  );
}
